import React, { useEffect, useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  Page,
  LayoutSingleColumn,
  Heading,
  Form,
  FieldTextInput,
  FieldSelect,
  Button,
} from '../../components';

import css from './ContactUsPage.module.css';
import ContactUsForm from './ContactUsForm';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { sendContactMessage, resetContactForm } from '../../ducks/contactUs.duck';

const supportEmail = 'support@groovebay.eu';

const ContactUsPageComponent = props => {
  const {
    scrollingDisabled,
    onSendContactMessage,
    onResetContactForm,
    sendMessageInProgress,
    sendMessageError,
    messageSent
  } = props;
  const intl = useIntl();
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (messageSent) {
      setShowSuccess(true);
      // Reset form after 5 seconds
      const timer = setTimeout(() => {
        setShowSuccess(false);
        onResetContactForm();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [messageSent, onResetContactForm]);

  const handleSubmit = async (values, form) => {
    try {
      await onSendContactMessage(values);
      setShowSuccess(true);
      form.restart();
      const timer = setTimeout(() => {
        setShowSuccess(false);
        onResetContactForm();
      }, 5000);
      return () => clearTimeout(timer);
    } catch (error) {
      console.error('Error sending contact message:', error);
    }
  };

  return (
    <div className={css.pageRoot}>
      <div className={css.layoutWrapperMain}>
        <div className={css.contentWrapper} id='top'>
          <div className={css.infoCard}>
            <Heading as="h1" className={css.infoHeading}>
              <FormattedMessage id="ContactUsPage.heading" />
            </Heading>
            <p className={css.infoText}>
              <FormattedMessage id="ContactUsPage.subheading" />
            </p>
            <p className={css.infoText}>
              <FormattedMessage id="ContactUsPage.helper" />
            </p>
            <hr className={css.infoDivider} />
            <div className={css.supportRow}>
              <IconCard brand="mail" />
              <div>
                <div className={css.supportTitle}>
                  <FormattedMessage id="ContactUsPage.supportTitle" />
                </div>
                <a className={css.supportEmail} href={`mailto:${supportEmail}`}>
                  {supportEmail}
                </a>
              </div>
            </div>

            <div className={css.helptext}>
              <FormattedMessage id="ContactUsPage.Sectiontitle" />
            </div>
            <div className={css.iconWrapper}>
              <IconCard brand="facebook" />
              <IconCard brand="instagram" />
              <IconCard brand="tiktok" />
              <IconCard brand="pinterest" />
            </div>
            <hr className={css.infoDivider} />
            <div className={css.CommunityTitle}>
              <FormattedMessage id="ContactUsPage.Sectionsubtitle" />
            </div>
          </div>

          <div className={css.formCard}>
            <Heading as="h2" className={css.formTitle}>
              <FormattedMessage id="ContactUsForm.title" />
            </Heading>

            <ContactUsForm
              showSuccess={showSuccess}
              sendMessageError={sendMessageError}
              className={css.form}
              onSubmit={handleSubmit}
              inProgress={sendMessageInProgress}
              messageSent={messageSent}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  const { sendMessageInProgress, sendMessageError, messageSent } = state.contactUs || {};
  return {
    scrollingDisabled: isScrollingDisabled(state),
    sendMessageInProgress,
    sendMessageError,
    messageSent,
  };
};

const mapDispatchToProps = dispatch => ({
  onSendContactMessage: params => dispatch(sendContactMessage(params)),
  onResetContactForm: () => dispatch(resetContactForm()),
});

const ContactUsPage = compose(
  connect(mapStateToProps, mapDispatchToProps)
)(ContactUsPageComponent);

export default ContactUsPage;
